import { Cart, CartLineInput } from './shopify';
import {
  API_URLS,
  TypeResponseError,
  TypeResponseSuccess,
  getJSONData,
  parseErrorMessage,
} from '@/lib/api/config';
import { getAuthTokenClient } from '@/utils/helpers';

export type TypeCartResponseSuccess = TypeResponseSuccess<Cart>;

export async function addToCart(
  lines: CartLineInput[],
  quantity: number,
  queryParams = {},
) {
  const body = JSON.stringify({ lines, quantity });
  const queryParamsString = new URLSearchParams(queryParams).toString();
  const config = {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: await getAuthTokenClient(),
    },
  };

  const response = await fetch(
    `${API_URLS.CART_SERVICE}/add${
      queryParamsString ? `?${queryParamsString}` : ''
    }`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeCartResponseSuccess;
}

export async function removeFromCart(lineIds: string[], queryParams = {}) {
  const body = JSON.stringify({ lineIds });
  const queryParamsString = new URLSearchParams(queryParams).toString();
  const config = {
    method: 'POST',
    body,
    headers: {
      'Content-Type': 'application/json',
      Authorization: await getAuthTokenClient(),
    },
  };

  const response = await fetch(
    `${API_URLS.CART_SERVICE}/remove${
      queryParamsString ? `?${queryParamsString}` : ''
    }`,
    config,
  );

  const { ok } = response;

  if (!ok) {
    return {
      ok,
      errorMessage: await parseErrorMessage(response),
    } as TypeResponseError;
  }

  return {
    ok,
    data: await getJSONData(response),
  } as TypeCartResponseSuccess;
}
